import React, { Suspense, lazy } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';

// Pages - Lazy loading dla lepszej wydajności
import Login from './pages/Login'; // Login nie lazy - potrzebny od razu
import Register from './pages/Register'; // Register też nie lazy
import Layout from './components/Layout/Layout'; // Layout też nie lazy

// Lazy loaded pages
const Dashboard = lazy(() => import('./pages/Dashboard'));
const DataSources = lazy(() => import('./pages/DataSources'));
const Templates = lazy(() => import('./pages/Templates'));
const Generator = lazy(() => import('./pages/Generator'));
const Scheduler = lazy(() => import('./pages/Scheduler'));
const History = lazy(() => import('./pages/History'));
const Integrations = lazy(() => import('./pages/Integrations'));
const SocialPreview = lazy(() => import('./pages/SocialPreview'));
const WordPress = lazy(() => import('./pages/WordPress'));
const Privacy = lazy(() => import('./pages/Privacy'));

// Loading component dla Suspense
const LoadingFallback = () => (
  <div className="flex items-center justify-center min-h-screen">
    <div className="text-xl">Ładowanie...</div>
  </div>
);

// Protected Route Component
const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();
  
  if (loading) {
    return <LoadingFallback />;
  }
  
  if (!isAuthenticated) {
    return <Navigate to="/login" />;
  }

  return (
    <Suspense fallback={<LoadingFallback />}>
      {children}
    </Suspense>
  );
};

function AppRoutes() {
  const { isAuthenticated } = useAuth();

  return (
    <Routes>
      <Route 
        path="/login" 
        element={<Login />} 
      />
      <Route 
        path="/register" 
        element={
          isAuthenticated ? (
            <Navigate to="/" />
          ) : (
            <Register />
          )
        } 
      />
      <Route 
        path="/privacy" 
        element={
          <Suspense fallback={<LoadingFallback />}>
            <Privacy />
          </Suspense>
        } 
      />
      
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <Layout />
          </ProtectedRoute>
        }
      >
        <Route index element={<Dashboard />} />
        <Route path="data-sources" element={<DataSources />} />
        <Route path="templates" element={<Templates />} />
        <Route path="generator" element={<Generator />} />
        <Route path="scheduler" element={<Scheduler />} />
        <Route path="history" element={<History />} />
        <Route path="integrations" element={<Integrations />} />
        <Route path="social-preview" element={<SocialPreview />} />
        <Route path="wordpress" element={<WordPress />} />
      </Route>
      
      <Route path="*" element={<Navigate to="/" />} />
    </Routes>
  );
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppRoutes />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;

